import App from "../layouts/App";

export default function NotFound() {
	return <App></App>;
}
